import { render, staticRenderFns } from "./FiltersSuppliers.vue?vue&type=template&id=4881c601&"
import script from "./FiltersSuppliers.vue?vue&type=script&lang=js&"
export * from "./FiltersSuppliers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports